import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ZustandStore } from "../../../store/zustand-store";
import { useLocation } from "react-router-dom";
import { handleInvitedUserProject } from "../../../helperJs/helper";
import Select from "@semcore/select";
import { ScreenReaderOnly } from "@semcore/flex-box";
import { Flex } from "@semcore/flex-box";
import { useTranslation } from "react-i18next";

const ProjectList = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [filter, setFilter] = useState("");

  const websiteurl = useSelector((state) => state.websiteurl);
  const userallprojectname = useSelector((state) => state.userallprojectname);
  const { emptyKeywordData, emptyAllLocData, emptyTagData, userAccessData } =
    ZustandStore((state) => state);

  const page_data = userAccessData?.[0]?.access;
  const excludedProjects = useMemo(
    () => handleInvitedUserProject("False", page_data),
    [page_data]
  );

  const access_project_list = useMemo(() => {
    if (!userallprojectname?.length) return [];
    if (!excludedProjects?.length) {
      return userallprojectname.map((project) => project.replace(", ", " - "));
    }
    return userallprojectname
      .filter((project) => !excludedProjects.includes(project))
      .map((project) => project.replace(", ", " - "));
  }, [excludedProjects, userallprojectname, location]);

  const website_domain = websiteurl
    ? websiteurl.replace(",", " -")
    : "Select a Project";

  const SelectPrName = (e) => {
    const select_project = e?.replace(" - ", ", ");
    if (website_domain === e) return;
    if (location?.pathname === "/guest/rank-tracker") return;
    sessionStorage.setItem("LAST_PRPJECT_SELECTED", select_project);
    ZustandStore.setState({
      selected_date: null,
      selected_rank_data: {
        data: [],
        loaded: false,
      },
      property_name: [],
      site_audit_data: [],
      site_audit_domain: "",
      site_audit_overview: [],
      improved: [],
      declined: [],
      google_console_data: [],
    });
    emptyTagData();
    emptyAllLocData();
    emptyKeywordData();
    dispatch({
      type: "USERCURRENTPROJECTLOCATION",
      payload: [],
    });
    dispatch({ type: "WEBSITEURL", payload: select_project });
    dispatch({ type: "USERANALYTICDATA", payload: [] });
    dispatch({ type: "USERANALYTICLOGIN", payload: false });
    dispatch({ type: "CURRENTLOCATIONCODE", payload: null });
    dispatch({ type: "CURRENTLOCATION", payload: null });
  };

  const options = useMemo(
    () =>
      access_project_list?.filter((value) => {
        return value.toString().toLowerCase().includes(filter.toLowerCase());
      }),
    [filter, access_project_list]
  );

  return (
    <Flex direction="column">
      <Select
        w="100%"
        value={website_domain}
        onChange={SelectPrName}
        placeholder={website_domain}
        disabled={location?.pathname === "/guest/rank-tracker" || !websiteurl}
      >
        <Select.Trigger
          id="options-filtering-advanced"
          style={{
            width: "100%",
            height: "35px",
          }}
          loading={!websiteurl}
        />
        <Select.Popper aria-label={"Project options with search"}>
          <Select.InputSearch
            value={filter}
            onChange={setFilter}
            aria-describedby={filter ? "search-result" : undefined}
          />
          <Select.List hMax={"224px"}>
            {options.map((value) => (
              <Select.Option
                value={value}
                key={value}
                style={{
                  boxShadow: "none",
                }}
              >
                {value}
              </Select.Option>
            ))}
            {options.length ? (
              <ScreenReaderOnly
                id="search-result-advanced"
                aria-hidden={"true"}
              >
                {options.length} {t("opportunities.result")}
                {options.length > 1 && "s"} found
              </ScreenReaderOnly>
            ) : (
              <Select.Option.Hint id="search-result-advanced" key="Nothing">
                {t("opportunities.nothing_found")}
              </Select.Option.Hint>
            )}
          </Select.List>
        </Select.Popper>
      </Select>
    </Flex>
  );
};

export default ProjectList;
